import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
import { inputBorderCss } from '../Field/Field.styled';
import { StyledInput } from './TextInput.styled';
export var StyledNumberInput = styled(StyledInput)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-bottom: 4px;\n\ttext-align: ", ";\n\twidth: ", ";\n\t", ";\n"])), function (props) {
  return props.textAlign;
}, function (props) {
  return props.width;
}, inputBorderCss);
export var StyledUnitsLabel = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmargin-left: 5px;\n"])));